// extracted by mini-css-extract-plugin
export var errorIcon = "_pp-1";
export var nameLogo = "_pp-0";